import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ActionButtons = ({ orderNumber, email, onResendEmail }) => {
  const [isResending, setIsResending] = useState(false);
  const [resendSuccess, setResendSuccess] = useState(false);
  const navigate = useNavigate();

  const handleResendEmail = async () => {
    setIsResending(true);
    try {
      await onResendEmail(orderNumber, email);
      setResendSuccess(true);
      setTimeout(() => setResendSuccess(false), 3000);
    } catch (error) {
      console.error('Failed to resend email:', error);
    } finally {
      setIsResending(false);
    }
  };

  const handleViewTickets = () => {
    navigate('/my-tickets');
  };

  const handleBrowseEvents = () => {
    navigate('/home');
  };

  const handleContactSupport = () => {
    // In a real app, this would open a support chat or email
    window.open('mailto:support@tixful.com?subject=Order Support - ' + orderNumber, '_blank');
  };

  return (
    <div className="space-y-4">
      {/* Primary Actions */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <Button
          variant="default"
          onClick={handleViewTickets}
          iconName="Ticket"
          iconPosition="left"
          className="w-full"
        >
          View My Tickets
        </Button>
        <Button
          variant="outline"
          onClick={handleBrowseEvents}
          iconName="Search"
          iconPosition="left"
          className="w-full"
        >
          Browse More Events
        </Button>
      </div>

      {/* Secondary Actions */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <Button
          variant="ghost"
          onClick={handleResendEmail}
          loading={isResending}
          iconName={resendSuccess ? "Check" : "Mail"}
          iconPosition="left"
          className="w-full"
        >
          {resendSuccess ? "Email Sent!" : "Resend Confirmation"}
        </Button>
        <Button
          variant="ghost"
          onClick={handleContactSupport}
          iconName="HelpCircle"
          iconPosition="left"
          className="w-full"
        >
          Contact Support
        </Button>
      </div>

      {/* Help Links */}
      <div className="pt-4 border-t border-border">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between space-y-2 sm:space-y-0">
          <div className="flex items-center space-x-4 text-sm">
            <button
              onClick={() => window.open('/refund-policy', '_blank')}
              className="text-muted-foreground hover:text-foreground transition-colors flex items-center"
            >
              <Icon name="FileText" size={14} className="mr-1" />
              Refund Policy
            </button>
            <button
              onClick={() => window.open('/help', '_blank')}
              className="text-muted-foreground hover:text-foreground transition-colors flex items-center"
            >
              <Icon name="HelpCircle" size={14} className="mr-1" />
              Help Center
            </button>
          </div>
          <div className="text-xs text-muted-foreground">
            Order #{orderNumber}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActionButtons;